export default {
  init() {
    const directoryIndexObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        let letter = $(entry.target).attr('id')
        if (entry.isIntersecting) {
          $('.directory-index').find('li').not(`li[data-letter="${letter}"]`).removeClass('active')

          $('.directory-index').find(`li[data-letter="${letter}"]`).addClass('active')
        }
      });
    }, {})

    $('.index-heading').each(function() {
      directoryIndexObserver.observe($(this).get(0))
    })

  },
}



// WEBPACK FOOTER //
// ./scripts/components/DirectoryIndexObserver.js